/**
 * @file: 画布外侧更新事件通信
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent } from '../message/index';
import Utils from '../utils/util';
import History from '../interaction/history/index';
import { run } from './run';
import { getCubeBeforeUpdateInfo } from './getCubeBeforeUpdateInfo';

interface SelectEditParams {
    cubeIds: Array<CubeId>,
    data: FreeObjMap,
    from: string,
    eventFrom: string
}

interface UpdateData {
    cubeIds: Array<CubeId>,
    data: FreeObjMap
}

export function initMessage(): void {
    StageEvent.on('selectEdit', (params: SelectEditParams): void => {
        if (params.eventFrom !== 'panel') {
            return;
        }
        let updateTasks: Array<UpdateTask> = updateDataTransform({
            cubeIds: params.cubeIds,
            data: params.data
        });
        let oldInfos: UpdateTask[] = getCubeBeforeUpdateInfo(updateTasks);

        History.stackIn({
            type: 'selectUpdate',
            data: oldInfos
        });
        run(updateTasks);
    });
}

// 更新数据格式转换
function updateDataTransform(params: UpdateData): Array<UpdateTask> {
    return params.cubeIds.map((cubeId: CubeId): UpdateTask => {
        return {
            cubeId,
            updateData: Utils.deepCopy(params.data)
        };
    });
}
